import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/Tooltip';
import { AppRoutes } from '@/constants/routes';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface WebhookDeliveryEventCellProps {
    eventId: string;
}

export function WebhookDeliveryEventCell({
    eventId,
}: WebhookDeliveryEventCellProps) {
    const { t } = useTranslation(I18nNamespace.ALERT_RULES);

    const openEvent = () => {
        window.open(
            generatePath(AppRoutes.EVENT, { eventId }),
            '_blank',
            'noopener,noreferrer',
        );
    };

    return (
        <div className="group/event flex items-center gap-2">
            <span className="font-geist-mono text-xs text-grey-200">
                {eventId}
            </span>
            <Tooltip delayDuration={0}>
                <TooltipTrigger asChild>
                    <button
                        type="button"
                        onClick={(event) => {
                            event.stopPropagation();
                            openEvent();
                        }}
                        aria-label={t('webhookDeliveries.openEvent')}
                        className="flex shrink-0 items-center justify-center rounded p-1 text-grey-200 opacity-0 transition-opacity hover:bg-surface-hover hover:text-white-100 focus-visible:opacity-100 group-hover/event:opacity-100"
                    >
                        <ArrowSquareOutIcon className="size-4" />
                    </button>
                </TooltipTrigger>
                <TooltipContent side="top">
                    {t('webhookDeliveries.openEvent')}
                </TooltipContent>
            </Tooltip>
        </div>
    );
}
